type DocumentToggleOptionsProps = {
  index: number;
  hasRemoveOption?: boolean;
  hasReplaceOption?: boolean;
  handleTranslate: (key: string) => string;
  handleRemove?: () => void;
  handleReplace?: () => void;
};

export const getToggleOptions = ({
  index,
  hasRemoveOption,
  hasReplaceOption,
  handleTranslate,
  handleRemove,
  handleReplace,
}: DocumentToggleOptionsProps) => {
  const options = [];

  if (hasRemoveOption) {
    options.push(
      <a
        className="d-flex cursor-pointer"
        key={`document-remove-option-${index}`}
        onClick={handleRemove}
      >
        <em className="icon ni ni-trash fs-20px" />
        <span className="ml-1">{handleTranslate('Remove')}</span>
      </a>
    );
  }

  if (hasReplaceOption) {
    options.push(
      <a
        className="d-flex cursor-pointer"
        key={`document-replace-option-${index}`}
        onClick={handleReplace}
      >
        <em className="icon ni ni-trash fs-20px" />
        <span className="ml-1">{handleTranslate('Replace')}</span>
      </a>
    );
  }

  return options;
};
